import { Attributes, Misc, ModelBase, Rules, Validation } from '@singularsystems/neo-core';

export default class InvestmentRate extends ModelBase {
static typeName = "InvestmentRate";

    constructor() {
        super();
        this.makeObservable();
    }

    public investmentRateId: number = 0;

    public investmentId: number = 0;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public effectiveDate: Date | null = null;

    @Attributes.Float(10)
    public rate: number = 0;

    @Attributes.Nullable()
    public rateCalculationTypeId: number | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<InvestmentRate>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New investment rate";
        } else {
            return "Investment Rate";
        }
    }
}